<template>
  <v-dialog
    :value="value"
    max-width="980"
    overlay-color="var(--ds-color-reverse)"
    @input="closeDialog"
  >
    <v-card class="pb-5">
      <v-toolbar
        width="100%"
        class="px-2"
        color="transparent"
        flat
      >
        <v-toolbar-title>
          {{ $t('components.HiddenCardsModal.label.title.hiddeCard') }}
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-row
        no-gutters
        class="mt-5 mx-5"
      />
      <v-card-text class="add-card-modal__description">
        {{ $t('components.HiddenCardsModal.label.description') }}
      </v-card-text>

      <v-card-actions class="px-6">
        <a
          href="https://suporte.stilingue.com.br/hc/pt-br/articles/4406728962450"
          target="_blank"
          class="add-card-modal__text_button"
        >
          {{ $t('components.HiddenCardsModal.label.button.aboutSharing') }}
        </a>
        <v-spacer />

        <DsButton
          color="secondary"
          @click="closeDialog"
        >
          {{ $t('components.HiddenCardsModal.label.button.cancel') }}
        </DsButton>
        <DsButton
          class="ds-margin-left-stack--xs"
          @click="continueAddCard"
        >
          {{ $t('components.HiddenCardsModal.label.button.confirm') }}
        </DsButton>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DsButton } from '@ds/components';
import { MUTATE } from '@/store/modules/mutation_types';
import { mapMutations } from 'vuex';

export default {
  name: 'HiddenCardsModal',
  components: {
    DsButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    closeDialog() {
      this.$emit('input', false);
      this.mutateMisc({
        property: 'addCardDrawer',
        with: true,
      });
    },
    continueAddCard() {
      this.$emit('addChart');
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped lang="scss">
  .add-card-modal {
    display: grid;

    &__description {
      width: 980px;
      font-size: 16px;
      margin-bottom: var(--ds-spacing-stack-xs);
    }

    &__text_button {
      color: var(--ds-color-icon-interactive);
      text-decoration: underline;
      text-transform: none;
    }
  }
</style>
